import { render } from "./AttrTasksPanel.vue?vue&type=template&id=096bfc3e&scoped=true"
import script from "./AttrTasksPanel.vue?vue&type=script&lang=js"
export * from "./AttrTasksPanel.vue?vue&type=script&lang=js"

import "./AttrTasksPanel.vue?vue&type=style&index=0&id=096bfc3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096bfc3e"],['__file',"src/components/widgets/components_core/AttrTasksPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "096bfc3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('096bfc3e', __exports__)) {
    api.reload('096bfc3e', __exports__)
  }
  
  module.hot.accept("./AttrTasksPanel.vue?vue&type=template&id=096bfc3e&scoped=true", () => {
    api.rerender('096bfc3e', render)
  })

}


export default __exports__